import { Component, Input } from '@angular/core';

import { ReferenceDataConstants } from '../../constants/reference-data-constants';
import { ReferenceDataLabels } from '../../constants/reference-data-labels';
import { AffordabilityResultsDto } from '../../models/dto/affordability-results-dto.model';

@Component({
  selector: 'boi-affordability-results',
  templateUrl: './affordability-results.component.html',
  styleUrls: ['./affordability-results.component.scss']
})
export class AffordabilityResultsComponent {
  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataConstants = ReferenceDataConstants;

  public readonly yearsString = 'yrs';
  public readonly monthsString = 'mths';

  @Input() public affordabilityResults: AffordabilityResultsDto;
}
